// ============================================================================
// Country Codes Configuration
// ============================================================================

/**
 * Country code configuration for phone number inputs
 */
export interface CountryCode {
  code: string;
  country: string;
}

/**
 * List of supported country codes
 */
export const COUNTRY_CODES: CountryCode[] = [
  { code: '+61', country: 'Australia' },
];
